//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { Opaque } from '@utils/opaque';

type TrackedSourceId = Opaque<string, 'TrackedSourceId'>;

function TrackedSourceIdFactory(trackedSourceId: string) {
  return trackedSourceId as TrackedSourceId;
}

const TrackedSourceId = TrackedSourceIdFactory;

export default TrackedSourceId;
